































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/agiles/components';
import resize from 'vue-resize-directive';

export enum editFlags
{
  add = 1,
  edit = 2,
  copy = 3,
}

@Component({
  directives: {
    resize,
  },
})
export default class ListView extends Vue {
  // 初期データはインスタンスプロパティとして宣言できます

  @Prop() public title?: string;
  @Prop() public sortOptions?: Array<{ value: string; text: string }>;
  @Prop() public items?: any[];
　@Prop() public comparer: (a:any,b:any)=> boolean;
  @Prop() public params: Common.LoadQuery;
  @Prop() public modelName: string;
  @Prop({ default: null }) public importQuery: Common.Query;
  @Prop({ default: null }) public exportQuery: Common.Query;
  @Prop({ default: null }) public perm: string;
  @Prop({ default: 'rgba(0,0,0,0)' }) public color: string;
  @Prop({ default: null }) public icon: string;
  @Prop({ default: null }) public svg: string;  
  @Prop({ default: false }) public fullSizeEditor: boolean;
  @Prop({ default: null }) public onCreate: (item: any) => Promise<any>;
  @Prop({ default: null}) public tourId:string;
  @Prop({ default: null }) public deleteHandler: () => Promise<void>;
  @Prop({ default: '' }) public gridKey: string;
  @Prop({ default: null }) public gridCaptions: Array<string>;
  @Prop({ default: null }) public gridWidths: Array<number>;
  @Prop({ default: null }) public gridVisibles: Array<number>;
  @Prop({ default: null }) public tooltip: string;
  @Prop({ default: '#d3d3d3'}) public borderColor: string;
  @Prop({ default: '#f3f1f1' }) public backColor: string;   
  @Prop({default:null}) public popup: Components.PopupEditor;  
  @Prop({ default: null }) public postAddHandler: () => {}; //新規追加後に後続処理を実施する
  @Prop({ default: null }) public checkStateObject: (item: any) => Promise<any>;

  // public get dialogEditor(): boolean {return false} ;
  public get dialogEditor(): boolean {return this.$api.spMode == false && this.$api.dialogEditorPreference && this.popup == null} ;
  public dialogMode:boolean = false; //ダイアログ表示用のダミーインスタンス
  public dialogTitle:string = null;

  public get isFavorite(){
    return this.$route.query.favorite != null;
  }
  public get favoriteFlagEnabled() :boolean {
    return this.isFavorite == false && this.$api.perms.hasMenuPermission(Common.Favorite.perm);
  }
  //検索ボタンの活性制御用
  public isFavoriteEditable :boolean = true;
  // public get isFavoriteEditable(){
  //   return this.isFavorite == false || this.favorite.isTenant == false || this.$api.perms.hasMenuPermission(Common.Favorite.perm);
  // }
  public get columnStyle() : boolean {
    return this.applyNewStyle && (this.isPopup == false) && (this.$api.spMode == false);
  };
  public applyNewStyle:boolean = false;
  public  initialSideWidth : number = 400;
  public initialBottom:number = 430;//480

  public minimizedBottom = false;
  public minimizedRight = false;

  public initializing:boolean = true;

  @Watch('applyNewStyle')
  public onApplyNewStyleChanged(){
    if (this.initializing) return ;
    localStorage.setItem('applyNewStyle',this.applyNewStyle ? 'true':'false');
    this.initialSideWidth = this.columnStyle ? 1000 : 400;
    // this.initialBottom = this.applyNewStyle ? 240 : 480;
    //編集画面を初期表示する
    if (this.applyNewStyle) {
        this.minimizedBottom = true;
        this.minimizedRight = false;
    } else {
        this.minimizedBottom = false;
        this.minimizedRight = true;
    }
    this.$nextTick(()=>{
        // this.onIsSideFilterChange();
        // if(this.isPopup == false && this.$api.spMode == false) this.setVisibleState(this.applyNewStyle ? 'minimum':'both');        
        // this.setVisibleState('both'); //上下をリセットする          
        if(this.isPopup == false && this.$api.spMode == false)
        {
          (this.$refs.sideFilterSplitter as Components.Splitter).reset(); 
          (this.$refs.verticalSplitter as Components.Splitter).reset();         
          this.$emit('resize');
        } 
      });//サイド幅調整を実行
 
  }

  public get headerStyle() : any {
    if (this.borderColor)
      return 'border-bottom: solid 2px ' + this.borderColor + ';' ;
    else
      return null;
  }
  public get style(): any {
    if (this.borderColor)
      return 'border-bottom: solid 1px ' + this.borderColor + '30; background-color:' + this.backColor + ';';
    else
      return null;
    // return 'box-shadow: inset 0 3px 0 0 ' + this.borderColor + ';';    
  }
  public get editorStyle():any{
    if (this.borderColor)
      return 'border-top: solid 2px ' + this.borderColor + ';';
    else
      return null;    
  }
  public get isPopup() { return this.popup ? true : false;}
  public get popupMode() {return this.popup ? this.popup.mode : null;} //null/editor/listの3モード
  public get insertOnPopup() {return this.popup? this.popup.isInsertMode : false}

  showUpload: boolean = false;
  bindIndex: number = 0;
  public get sortCaptions() {
    if (this.sortOptions == null) return [];
    else return this.sortOptions.map(obj => obj.text);
  }
  public get sortCaption() {
    if (this.sortOptions != null || this.sortOptions.findIndex(obj => obj.value == this.params.sort) != -1) return this.sortOptions.find(obj => obj.value == this.params.sort).text;
    else return '';
  }
  public onSort(caption: string) {
    const sort = this.sortOptions.find(obj => obj.text == caption);
    if (this.params.sort == sort.value) {
      this.params.isDescending = !this.params.isDescending;
    } else {
      this.params.sort = sort.value;
      this.params.isDescending = false; //昇順にリセットする
    }
    this.onPageChange(1);
  }
  public checked: boolean[] = new Array(0);
  public selected: any = null;
  public currentId: number = -1;
  public isLoading: boolean = false;
  public currentPage: number = 1;
  public totalRows: number = 0;
  public perPage: number = 10;
  public sort: string = '';
  public search: string = '';
  public filters: any;
  public isSideFilter: boolean = true;
  public isInsertMode: boolean = false;
  public editFlag: editFlags = null; //isInsertModeのみでは判断できないため追加
  public showFavorite: boolean = false;
  public favoriteName: string = '';
  public favorite: Common.Favorite = null;  

  public editor: Components.Editor = null;
  public sideEditor: Components.Editor = null;
  public editorHalfHeight:boolean = false;
  // public showAlert: boolean = false;
  // public alertTitle: string = '';
  // public alertMessage: string = '';
  // public okOnly: boolean = false;
  // public exec: () => void = () => { }; //ダミー
  public isEdit: boolean = false; //ダミー
  public isEditting: boolean = false;
  public favTitle: string = null;
  public pageDescription:string = null;
  public get isAdding() {return this.editFlag == editFlags.add;}
  public get isSideMenu() {
    if( this.$root.$children[0] == this)  return false;
    return (this.$root.$children[0] as any).isSideMenu;
  }
  public set isSideMenu(value: boolean) {
    if( this.$root.$children[0] == this)  return;
    (this.$root.$children[0] as any).isSideMenu = value;
  }

  public listVisible: boolean = true;
  public editorVisible: boolean = true;  
  public setVisibleState(state: string) {
    if (state == 'list') {
      this.listVisible = true;
      this.editorVisible = false;
      this.minimizedBottom = true;
    } else if (state == 'editor') {
      this.listVisible = false;
      this.editorVisible = true;
    } else if (state == 'both') {
      this.listVisible = true;
      // this.editorVisible = true;
      this.editorVisible = false;      //個別画面の非表示化
      // this.initialBottom = 480;           
      // if(this.$refs.verticalSplitter) this.$nextTick(()=>{if(this.$refs.verticalSplitter){(this.$refs.verticalSplitter as Components.Splitter).reset();this.$emit('resize');}}); //上下をリセットする
      this.minimizedBottom = false;        
      this.$emit('resize');   
    } else if (state == 'minimum'){
      this.listVisible = true;
      this.editorVisible = true;
      // this.initialBottom = 50;     
      // if(this.$refs.verticalSplitter) this.$nextTick(()=>{if(this.$refs.verticalSplitter){(this.$refs.verticalSplitter as Components.Splitter).reset();this.$emit('resize');}}); //上下をリセットする      
      this.minimizedBottom = true;       
      this.$emit('resize');
    }
    

  }

  @Watch('$api.spMode')
  onSpModeChanged(){
    if (this.$api.spMode) this.setVisibleState('list');
    // else this.setVisibleState(this.minimizedBottom ? 'minimum' : 'both');    
    else this.setVisibleState(this.minimizedBottom ? 'list' : 'both');        
  }
  onSearchClick(){
    this.isSideFilter = true;
  }

  private listUpdate() {
    this.$forceUpdate();
  }
  private created() {
    this.$emit('created',this); //オーバーライド用
    //トライアルユーザーの初期状態を左右配置に設定=>初期状態を上下に設定
    //if(this.$api.license.isTrial && localStorage['applyNewStyle'] == null && window.innerWidth >=1366)  localStorage['applyNewStyle'] = 'true';
    //this.applyNewStyle = localStorage.getItem('applyNewStyle') == 'true';
    this.applyNewStyle = false; //左右配置を廃止
    this.initialSideWidth = this.columnStyle ? 1000 : 400;    
    this.$nextTick(()=>this.initializing = false);

    //遅延ロード時の再描画用
    // this.$api.formatter.subscribe(this.listUpdate);
　　 this.$api.formatter.suspendLoading();
    if (this.popupMode == 'editor') this.isSideFilter = false;
    else if (this.popupMode == 'list') this.isSideFilter = true;
    // else this.isSideFilter = true; //初期値は最小化
    else  this.isSideFilter = localStorage.sideFilter != 'false';     //検索パネルの表示回復(初期表示)
    if (this.$api.spMode) this.isSideFilter = false; //強制的にOFF

    if (this.popup) this.popup.svg = this.svg;

    // if (localStorage['perPage']) {
    //   this.params.perPage = parseInt(localStorage['perPage'], 10); 
    // }    
    this.params.perPage = 100; //固定
    //ペーンの初期値を最小化に変更
    if (this.isPopup == false){
      this.minimizedRight = (localStorage.minimizedRight == null) ||  localStorage.minimizedRight == 'true';　//初期値は最小化    
      this.minimizedBottom =  localStorage.minimizedBottom != 'false';　//初期値は最小化
    }

    if (this.sortOptions && this.sortOptions.length > 0){
      //クエリ側のsort初期値を上書き
      this.params.sort = this.sortOptions[0].value;   
      var key = localStorage['sort.' + this.gridKey + '.key'];
      if (key && this.sortOptions.find(obj =>obj.value == key)) this.params.sort = key; //有効な値であることを検証
      var isDescending = localStorage['sort.' + this.gridKey + '.isDescending'];
      if (isDescending) this.params.isDescending = isDescending == 'true';    
    } 

    //★一覧ロードがゼロ件で新規追加する歳にワークフローの初期値が設定されない問題の修正(list='workflow_'をformatterにpushすることが目的)★
    if (this.onCreate && this.modelName){
      const temp = this.$api.createInstance(this.modelName);       
      this.onCreate(temp);
    }

    //お気に入りのロード ポップアップ表示の場合ロードしない
    if (this.$route.query.favorite != null && !this.popup) {
      // const binder = this.$api.createBinder(this.params.className); //this.$api.binders[this.params.className];
      const binder = this.params.binder; //クエリのbinderを再利用する(発注一覧の複製不具合)
      // const id = Number.parseInt(this.$route.query.favorite as string);
      const key = this.$route.query.favorite as string;
      // this.$api.find('Favorite', [id]).then(res => {
      this.$api.execute(new Common.FavoriteLoadQuery(key)).then(res => {
        this.favorite = res;
        this.isFavoriteEditable = this.isFavorite == false || this.favorite.isTenant == false || this.$api.perms.hasMenuPermission(Common.Favorite.perm);
        let params = binder.loadInstance(JSON.parse(res.json));
        params.perPage = this.params.perPage;
        var handler = this.onParamChange;
        this.onParamChange = ()=> null; //パラメータバインド時のchangeイベントを無効化
        this.$emit('update:params', params);
        this.favTitle = String.format('{0} ({1})',this.$translate(this.title),res.name);        
        this.$nextTick(() => {this.onPageChange(1); this.onParamChange = handler;});//パラメータバインド時のchangeイベントを有効化
      });
    } else {
      this.$nextTick(() => this.onPageChange(1));
    }
    //キャンペーン初期化
    this.onCampaignClose();

    
    //document.body.addEventListener('keydown', this.onKeyDown);
    this.$api.sckeys.add('ArrowLeft', this.onPageBefore);
    this.$api.sckeys.add('ArrowRight', this.onPageNext);
    this.$api.sckeys.add('F5', this.onSideChange);
    //SPモードを初期化
    this.onSpModeChanged();
  }

  public destroyed() {
    // this.$api.formatter.unsubscribe(this.listUpdate);

    // document.body.removeEventListener('keydown', this.onKeyDown);
    this.$api.sckeys.remove('ArrowLeft', this.onPageBefore);
    this.$api.sckeys.remove('ArrowRight', this.onPageNext);
    this.$api.sckeys.remove('F5', this.onSideChange);
  }
  public mounted(){
    if(this.tooltip) this.$api.tooltip.mount(this, this.$refs.tooltip_target as Element,this.tooltip);      

    //popup時の処理
    if(this.popupMode == 'editor')  {
      this.setVisibleState('editor');

      if (this.insertOnPopup) {
        this.onAdd();
      } 
      (this.sideEditor as Vue).$emit('update:closeVisible', false);

    }    
    else if (this.popupMode == 'list'){
      this.setVisibleState('list');      
    }
  }
  @Watch('isSideFilter')
  public onSideFilterChanged() {
    localStorage.sideFilter = this.isSideFilter;
  }
  @Watch('minimizedBottom')
  public onMinimizedBottom(){
    if (this.isPopup == false){
      localStorage.minimizedBottom = this.minimizedBottom;
      this.$emit('resize');      
    }
  }
  @Watch('minimizedRight')
  public onMinimizedRight(){
     if (this.isPopup == false)localStorage.minimizedRight = this.minimizedRight;
  }
  @Watch('items')
  public onItemsChanged(newValue: any[], oldValue: any[]) {
    if (newValue == oldValue && this.partialLoading == false) {
      this.listSelect(this.currentId, false);
    }
  }
  public onPageBefore(): boolean {
    if ((this.$refs.listBox as Components.Grid).hasFocus == false) return false;

    if (this.params.currentPage > 1) {
      this.onPageChange(this.params.currentPage - 1);
    }
    return true;
  }
  public onPageNext(): boolean {
    if ((this.$refs.listBox as Components.Grid).hasFocus == false) return false;

    if (this.params.currentPage * this.params.perPage < this.totalRows) {
      this.onPageChange(this.params.currentPage + 1);
    }
    return true;
  }
  public onSideChange() {
  this.minimizedRight = !this.minimizedRight;
    // this.isSideFilter = !this.isSideFilter;
    return true;
  }
  // public onKeyDown(ev: KeyboardEvent){
  //   //左右キーでページ変更・F8でフィルタ表示
  //   //フィルタ表示中かエディタが読取モードの時だけ処理する
  //   if ( this.isSideFilter || (this.$refs.editor as Components.Editor).editorState == Common.editorStates.Read){
  //     if (ev.key=="ArrowRight"){
  //       if (this.params.currentPage * this.params.perPage < this.totalRows){
  //         this.onPageChange(this.params.currentPage + 1);
  //         ev.preventDefault();
  //       }
  //     } else if (ev.key=="ArrowLeft"){
  //       if (this.params.currentPage >1){
  //         this.onPageChange(this.params.currentPage - 1);
  //         ev.preventDefault();
  //       }
  //     } else if (ev.key=="F5"){
  //         this.isSideFilter = !this.isSideFilter;
  //         ev.preventDefault();
  //     }
  //   }
  // }

  public options(): any {
    return [
      { value: 10, text: '10' },
      { value: 20, text: '20' },
      { value: 50, text: '50' },
      { value: 100, text: '100' },
    ];
  }

  // public showDialog(
  //   title: string,
  //   message: string,
  //   okOnly: boolean,
  //   exec: () => void
  // ) {
  //   this.alertTitle = title;
  //   this.alertMessage = message;
  //   this.okOnly = okOnly;
  //   this.exec = exec;
  //   this.showAlert = true;
  // }
  //#region ロード処理

  public async reload(){
    //選択行のみ復元し、チェックボックスは復元しない
    //別ユーザーによる更新や完了によって抽出対象外となった場合などで、該当行とは異なる行が選択される場合がある
    //idチェックによる再選択も検討したが、ページアウトするケースはいずれにしても対応できないので、妥協しました。
    var selectedId = this.selectedId();
    return this.onPageChange(this.params.currentPage).then(()=>{this.listSelect(selectedId);});
  }

  public async reloadSelected(){
    if (this.selected) {
      var selectedId = this.selectedId();      
      this.$api.reload(this.selected).then(obj =>{
        this.$set(this.items, selectedId,obj);
        this.listSelect(selectedId);
      });
    }
  }

  public onParamChange() {
    this.onPageChange(1);
  }

  public async onPageChange(index: number) {
    //popupエディタで追加する際はロード無効化～dialogModeはcreated直後は設定されていないため$rootで判定
    if (this.insertOnPopup || this.$root.$el.className == 'cx_listView') {
      if (this.$api.formatter.hasPendingRequests()){
        this.$api.formatter.loadPendingLists();
      } else {
        this.$api.formatter.resumeLoading();//遅延ロードが発生しなかった場合はフラグを戻す
      }      
      if (this.insertOnPopup)this.popup.isLoading = false;
      return;
    }

    if (this.popup && this.popup.mode =='list') this.popup.isLoading = false; //リストモードの場合はポップアップ側のローディングを停める
    this.isLoading = true;    
    this.params.currentPage = index;
    if(this.$api.spMode == false) localStorage['perPage'] = this.params.perPage;
    //不要な値は書き込まない
    if (this.sortOptions && this.sortOptions.length > 0){
      localStorage['sort.' + this.gridKey + '.key'] = this.params.sort;    
      localStorage['sort.' + this.gridKey + '.isDescending'] = this.params.isDescending;   
    }

    //非表示の場合に更新しない
    if (this.$api.spMode){
      var defaultRowCount = (this.$refs.listBox as Components.Grid).defaultRowCount;
      if(defaultRowCount != 0) this.params.perPage = defaultRowCount + 1;
    }

    return this.$api
      .execute(this.params)
      .then((data: Common.LoadResult) => {
        //保留モードにセットする
        this.$api.formatter.suspendLoading();

        //等価比較関数がセットされていない場合はチェック項目を残さない
        //チェックされている項目を残す
        var checkedItems = new Array(0);
        if(this.items && this.comparer){
          this.items.forEach((obj, index) => {
            if ((this.$refs.listBox as Components.Grid).checked[index]) {
              checkedItems.push(obj);
            }
          });
        }

        checkedItems = new Array(0); //チェック項目を残さない仕様に戻す
        const checkedCount = checkedItems.length;
        //重複した項目を削除する
        const loadedItems = new Array(0);
        data.result.forEach(a =>{
          let found = false;
          checkedItems.forEach(b=> found = found || this.comparer(a,b))
          if (found == false) loadedItems.push(a);
        });
        

        this.totalRows = data.records;

        //this.items = data.result;
        this.$emit('update:items', checkedItems.concat(loadedItems));

        //itemsの更新後に再度チェックする。
        if (checkedCount > 0){
          this.$nextTick(()=>{
            for(var i:number = 0; i<checkedCount;i++){
              (this.$refs.listBox as Components.Grid).updateChecked(i,true);
            }
          });
        }

        //this.isLoading = false;
        if (data.result.length > 0) {
          //初期選択をポップアップエディタに限定
          if(this.popup && this.editorVisible){
            // this.selected = data.result[0];
            this.$nextTick(()=>{this.listSelect(0);});
          }
        } else {
          this.selected = null;
        }

        this.currentPage = index;

        var startCount = this.params.perPage * (this.currentPage -1) +1;
        var endCount = Math.min(this.params.perPage * this.currentPage, data.records);
        if(endCount == 0) this.pageDescription = String.format('全体 {0} 件',this.$api.formatter.formatNumber(data.records,0));
        else this.pageDescription = String.format('{0} - {1} 件 (全体 {2} 件)',
          this.$api.formatter.formatNumber(startCount,0),this.$api.formatter.formatNumber(endCount,0),this.$api.formatter.formatNumber(data.records,0));

        this.$forceUpdate();
        //フィルタ表示中はフォーカスを取得しない
        if (this.isSideFilter == false) {
          this.$nextTick(() => (this.$refs.listBox as Components.Grid).focus());
          console.log('focus');
        }
        //描画終了後に保留リストをロードし、Grid/Editorを強制更新する(:keyを変更)
        this.$nextTick(()=>{
          if (this.$api.formatter.hasPendingRequests()){
            this.$api.formatter.loadPendingLists().then(()=>{
              this.bindIndex+=1;
              this.isLoading = false;
              if (this.popup)this.popup.isLoading = false;
            });
          } else {
            this.isLoading = false;
            this.$api.formatter.resumeLoading();//遅延ロードが発生しなかった場合はフラグを戻す
            if (this.popup)this.popup.isLoading = false;            
          }
        });
      })
      .catch(() => {
        this.isLoading = false;
        this.$api.formatter.resumeLoading();//遅延ロードが発生しなかった場合はフラグを戻す        
        if (this.popup)this.popup.isLoading = false;
        });
  }
  //#endregion

  //#region 編集・新規追加・複製・削除
  public onOpenDialog(){
      // this.openDialogEditor(this.$api.createBinder(this.modelName).loadInstance(this.items[this.currentId]),editFlags.edit);
      this.editFlag = editFlags.edit;
      this.openEditor(Common.editorStates.Read);
  }
  public onOpenDialogByIndex(index:number){
    this.listSelect(index);
    this.onOpenDialog();
  }
  public onEdit(permDialogEditor: boolean = true) {
    //ダイレクトエディット中は除外
    if (this.isDirectEditting) return;

    if ((this.$api.spMode && this.editorVisible == false) || this.popup) this.setVisibleState('editor');
    //携帯モードで以前からデグレがあったため修正。dialogEditorが有効化されている場合は現状維持する。
    else if (this.$api.spMode == false && this.dialogEditor == false){
      if (this.columnStyle) this.isSideFilter = true;
      else this.setVisibleState('both');
    }

    const item = this.items[this.currentId];
    var perm = this.$api.perms.hasMenuPermission(this.perm ? this.perm + '.edit' : '');
    let message = '更新権限がありません。';

    const isStateObj = item instanceof Common.StateObject;
    //新規追加・複製時はワークフロー権限を適用しない。
    if (perm && (isStateObj || (this.checkStateObject && this.checkStateObject(item)))) {
      //エッジステータスの判定
      let sObj : any = null;
      if(this.checkStateObject) sObj = this.checkStateObject(item);
      else sObj = item as Common.StateObject;

      //事前アクションの表示処理
      var action = this.$api.perms.getDefaultAction(sObj.workflowCode, sObj.workflowId, sObj.workflowStateId, sObj.getTargetState(sObj.workflowStateId, Common.DefaultActionFlags.edit));    
      if (action){
        //デフォルトアクションボタンを表示する～複数の可能性もあるかも
        this.$api.modal.showDialog('先行アクション','編集する場合は事前に「' + action.actionName + '」を実施してください。',false, action.actionName,'キャンセル')
        .then(()=>this.$api.send(sObj,action.stateIdTo))
        .then(obj =>{
          //リストを更新して再度編集処理を実行する
          // this.$set(this.items, this.currentId, obj);
          this.onWorkflow(this.currentId, obj);//ワークフロー更新用 
          this.$nextTick(()=>this.onEdit());
        });        
        return;
      }

      if (sObj.isClosed) {
        //終端点は編集不可
        perm = false;
        //stateObjectでmessageOnEditをオーバーライドしているのはOrder/Delivery/Invoiceのみ。
        //それ以外はstateObject.messageOnEdit:='ワークフローが進行しているため編集できません。'が呼び出される
        message = sObj.messageOnEdit; 
        // message = 'ワークフローが完了しているため編集できません。';        
      } else {
        perm = perm && this.$api.perms.hasWorkflowPermission(sObj.workflowHolder);
        message = 'ワークフローが割当てられていないため編集できません。';
      }
    }

    if (perm == false) {
      this.$api.modal.show('無効な操作', message, true, null);
      this.isInsertMode = false;
      this.editFlag = editFlags.edit;          
      // this.currentId = this.selectedId();
      this.openEditor(Common.editorStates.Read);
      return; //もしくは編集モードで開く
    }

    //詳細ボタンで開く形に変更
    // if (this.dialogEditor && permDialogEditor) {
    //   this.openDialogEditor(this.$api.createBinder(this.modelName).loadInstance(this.items[this.currentId]),editFlags.edit);
    //   return;
    // }

    this.isInsertMode = false;    
    this.editFlag = editFlags.edit;    

    this.selected = this.$api.createBinder(this.modelName).loadInstance(this.items[this.currentId]);
    // this.currentId = this.selectedId();
    this.openEditor();

    // if (this.isSideFilter) {
    //   this.isEditting = true;
    // }

    // this.$nextTick(() => {
    //   (this.$refs.editor as Components.Editor).setState(Common.editorStates.Edit);
    // });
  }

  public hasDirectPerm(): boolean {
    const item = this.items[this.currentId];
    var perm = this.$api.perms.hasMenuPermission(this.perm ? this.perm + '.edit' : '');

    const isStateObj = item instanceof Common.StateObject;
    //新規追加・複製時はワークフロー権限を適用しない。
    if (perm && (isStateObj || this.checkStateObject)) {
      //エッジステータスの判定
      let sObj : any = null;
      if(this.checkStateObject) sObj = this.checkStateObject(item);
      else sObj = item as Common.StateObject;
      if (sObj.isClosed) {
        //終端点は編集不可
        perm = false;
      } else {
        perm = perm && this.$api.perms.hasWorkflowPermission(sObj.workflowHolder);
      }
    }
    return perm;
  }

  public isDirectEditting :boolean = false;
  public onDirectEdit() {
    //クローン
    this.selected = this.$api.createBinder(this.modelName).loadInstance(this.items[this.currentId]);
    this.isDirectEditting = true;
  }

  public onDirectCommit() {
    this.isDirectEditting = false;
    this.$api.update(this.selected).then(obj => {      
      // 配列を更新して再選択する
      this.$set(this.items, this.currentId, obj);
      this.$nextTick(() => this.listSelect(this.currentId, false));
    }).catch(()=>{
      //ロールバックする
      this.$nextTick(() => this.listSelect(this.currentId, false));      
    });
  }

  public onDirectClose() {
    this.isDirectEditting = false;    
    //編集用のクローンを破棄する
    this.listSelect(this.currentId, false);
    // this.$nextTick(() => this.listSelect(this.currentId));
  }

  public onAdd() {

    //ダイレクトエディット中は除外
    if (this.isDirectEditting) return;

    if ((this.$api.spMode && this.editorVisible == false) || this.popup) this.setVisibleState('editor');
    //携帯モードで以前からデグレがあったため修正。dialogEditorが有効化されている場合は現状維持する。
    else if (this.$api.spMode == false && this.dialogEditor == false){
      if (this.columnStyle) this.isSideFilter = true;
      else this.setVisibleState('both');
    }

    // if (this.$api.perms.hasMenuPermission(this.perm + '.add') == false) {
    //   this.$api.modal.show('無効な操作', '追加権限がありません。', true, null);
    //   return;
    // }

    this.isInsertMode = true;
    this.editFlag = editFlags.add;
    // this.currentId = this.selectedId();
    const temp = this.$api.createInstance(this.modelName); //this.$api.binders[this.modelName].createInstance();
    if (this.onCreate != null) {
      this.onCreate(temp).then(obj => {
        // if (this.dialogEditor) {
        //   this.openDialogEditor(obj,editFlags.add);
        //   return;
        // }        
        this.selected = obj;
        this.openEditor();
        this.$emit('selected', -1, this.selected);        
      });
    } else {

      // if (this.dialogEditor) {
      //   this.openDialogEditor(temp,editFlags.add);
      //   return;
      // }          
      // リストの選択状態は変更しない。
      this.selected = temp;
      this.openEditor();
      this.$emit('selected', -1, this.selected);

    }
    //新規・複製でもselectedイベントを送出する
    //this.$emit('selected', -1, this.selected);

    // if (this.isSideFilter) {
    //   this.isEditting = true;
    // }

    // this.$nextTick(() => {
    //   (this.$refs.editor as Components.Editor).setState(Common.editorStates.Edit);
    // });
  }

  public onCopy() {
    // if (this.$api.perms.hasMenuPermission(this.perm + '.copy') == false) {
    //   this.$api.modal.show('無効な操作', '複製権限がありません。', true, null);
    //   return;
    // }
    // this.currentId = this.selectedId();
    if ((this.$api.spMode && this.editorVisible == false) || this.popup) this.setVisibleState('editor');
    //携帯モードで以前からデグレがあったため修正。dialogEditorが有効化されている場合は現状維持する。
    else if (this.$api.spMode == false && this.dialogEditor == false){
      if (this.columnStyle) this.isSideFilter = true;
      else this.setVisibleState('both');
    }

    const target = this.items[this.currentId];
    this.isInsertMode = true;
    this.editFlag = editFlags.copy;

    try {
      // if (this.dialogEditor) {
      //   this.openDialogEditor(target.copy(),editFlags.copy);
      //   return;
      // }         
      this.selected = target.copy(); //this.$api.createBinder(this.modelName).loadInstance(target);      
    } catch (e) {
      this.$api.modal.show('無効な操作', e.message, true, null);    
      return;  
    }    


    this.openEditor();

    //新規・複製でもselectedイベントを送出する
    this.$emit('selected', -1, this.selected);

    // if (this.isSideFilter) {
    //   this.isEditting = true;
    // }
    // this.$nextTick(() => {
    //   (this.$refs.editor as Components.Editor).setState(Common.editorStates.Edit);
    // });
  }

  //ダイアログ表示中のレコード移動
  public get hasPrevious():boolean {return this.currentId > 0 && (this.isInsertMode == false);};
  public get hasNext():boolean {return this.currentId < this.items.length-1 && (this.isInsertMode == false);}
  public moveItem(direction:string): any {
    var targetId = direction == 'previous' ? this.currentId -1 : this.currentId + 1;
    this.listSelect(targetId);
    return this.items[targetId];
  }


  //ダイアログモードで表示
  public showDialogEditor(obj:any,editFlag: editFlags){
    //単独起動されたVue
    this.dialogMode = true;    
    this.isEditting = true;
    this.selected = obj;
    this.editFlag = editFlag;
    this.$emit('update:items',[obj]);
    this.$nextTick(()=>{
      if (editFlag == editFlags.edit) this.onSelected(0); //selectedMainハンドラをトリガー
      else  this.$emit('selected', -1, this.selected);   //新規・複製の場合はイベント創出時のindexを-1にする必要がる。 

      this.isInsertMode = editFlag == editFlags.edit ? false : true;
      this.dialogTitle = editFlag == editFlags.add ? '新規追加' : editFlag == editFlags.edit ?  '詳細' : '複製';
      if(editFlag == editFlags.edit) this.openEditor(Common.editorStates.Read); 
      else this.openEditor();
    });
  }
  //同一の一覧画面の別インスタンスをダイアログモードで起動して編集を開始
  // public openDialogEditor(obj:any, editFlag: editFlags){

  //   let componentClass = Vue.extend(this.$parent.constructor); 
  //   var router = this.$router;
  //   let instance = new componentClass({
  //       router,
  //       propsData: this.$parent.$props, //一覧のpropsはrouterから付与された後は変更されないので、共有しても問題ないはず。
  //     });    

  //   instance.$mount();    
  //   this.$el.appendChild(instance.$el);    
        
  //   instance.$nextTick(()=>{
  //     let listView = instance.$refs.mainList as ListView;
  //     // listView.onExec = (item:any) =>{
  //     //   return this.onExec(item).then(()=>{
  //     //     listView.isEditting == false ; 
  //     //     listView.sideEditor.setState(Common.editorStates.Read);
  //     //     instance.$el.parentElement.removeChild(instance.$el); 
  //     //     instance.$destroy();  
  //     //   });
  //     // };//コミット時点で処理を戻す

  //     //更新したオブジェクトで呼び出し元のリストを更新する
  //     listView.onSubmit = (item:any) =>{
  //       // listView.sideEditor.setState(Common.editorStates.Read);
  //       // listView.$set(listView.items, listView.currentId, item);
  //       // listView.$nextTick(() => listView.listSelect(listView.currentId));        
  //       //ダイアログ側で明細追加を呼び出し
  //       if (listView.editFlag == editFlags.add && listView.postAddHandler){
  //         listView.editFlag = editFlags.edit; //明細更新後にonSubmitが再度呼び出されるので二重処理を回避
  //         listView.isInsertMode = false;
  //         listView.selected = item;
  //         listView.postAddHandler();
  //       }
  //       return this.onSubmit(item).then(()=>{
  //         listView.hasPrevious = this.currentId > 0;
  //         listView.hasNext = this.currentId < this.items.length -1;    
  //         listView.showDialogEditor(item,editFlags.edit);      
  //       });
  //     };//コミット時点で処理を戻す      
  //     listView.onClose =  () =>{
  //       listView.dialogMode = false ;  
  //       instance.$el.parentElement.removeChild(instance.$el);
  //       instance.$destroy();               
  //       this.onClose();
  //     };
  //     //レコードの移動
  //     listView.moveItem = (direction:string) =>{
  //       var selected = this.moveItem(direction);
  //       listView.hasPrevious = this.currentId > 0;
  //       listView.hasNext = this.currentId < this.items.length -1;        
  //       listView.showDialogEditor(selected,editFlags.edit);        
  //     }
  //     if (editFlag == editFlags.add || editFlag == editFlags.copy){
  //       var onCancel = listView.onCancel;
  //       listView.onCancel =  () =>{
  //         if (listView.editFlag == editFlags.add || listView.editFlag == editFlags.copy) {
  //           listView.dialogMode = false ;
  //           instance.$el.parentElement.removeChild(instance.$el);
  //           instance.$destroy();           
  //           this.onCancel();
  //         } else {
  //           //新規保存・複製保存後のキャンセルは通常処理
  //           onCancel();
  //         }
  //       };
  //     } else {
  //       listView.hasPrevious = this.currentId > 0;
  //       listView.hasNext = this.currentId < this.items.length -1;
  //     }
  //     listView.showDialogEditor(obj,editFlag);
  //   });



  // }

  public openEditor(state: Common.editorStates = Common.editorStates.Edit) {
    if(this.$api.spMode == false && !this.popup ) {
      this.dialogMode = true;        
      // this.setVisibleState('list');  //下部エディタを閉じる        
      this.dialogTitle = this.editFlag == editFlags.add ? '新規追加' : this.editFlag == editFlags.edit ?  '詳細' : '複製';   
    } 
    if (this.fullSizeEditor == false) {
      //サイドエディタの表示
      //this.isSideFilter = false;
      this.$nextTick(() => {
        this.sideEditor.setState(state);
      });
    } else {
      //フルサイズエディタの表示
      this.isEditting = true;
      this.$nextTick(() => {
        this.editor.setState(state);
      });
    }
  }
  public onDelete() {
    var auditNoList = this.items.filter((value, index) =>(this.$refs.listBox as Components.Grid).checked[index]).map(obj => new Common.BindItem((obj as Common.ObjectBase).auditNo,(obj as Common.ObjectBase).auditName));
    if (auditNoList.length == 0) {
      this.$api.modal.show('無効な操作', '削除する行を選択してください。', true, null);
    }        
    this.$api.execute(new Common.HasProvisioningDataQuery(auditNoList)).then(hasProvisioningData => this.onDeleteExec(hasProvisioningData));
  }
  public onDeleteExec(hasProvisioningData : boolean) {
    // if (this.$api.perms.hasMenuPermission(this.perm + '.delete') == false) {
    //   this.$api.modal.show('無効な操作', '削除権限がありません。', true, null);
    //   return;
    // }

    let count = 0;
    (this.$refs.listBox as Components.Grid).checked.forEach(obj => (count += obj ? 1 : 0));

    var hasStateObj: boolean = false;
    var hasDifferenceState: boolean = false;
    if (count > 0) {
      const targetList = new Array(0);
      this.items.forEach((obj, index) => {
        if ((this.$refs.listBox as Components.Grid).checked[index] && obj instanceof Common.StateObject) {
          const stateObj = obj as Common.StateObject;
          //開始ステータスの場合だけ削除できる=>2020.3.3 haramoto フラグ化対応
          //hasStateObj = hasStateObj || (this.$api.perms.getWorkflowState(obj.workflowCode, obj.workflowId, obj.workflowStateId).type & Common.StateTypes.EntryStatus)  != Common.StateTypes.EntryStatus;
          //テナント設定で確定状態の削除も許可
          hasStateObj = hasStateObj || (obj.isDeletable(this.$api) == false);          
        } else if((this.$refs.listBox as Components.Grid).checked[index] && obj instanceof Common.StateObject2) {
          const stateObj = obj as Common.StateObject2;
          //削除可能stateの場合だけ削除できる
          hasStateObj = hasStateObj || (stateObj.isDeletable == false);
        }
      });
      if (this.items[0] && (this.items[0] instanceof Common.StateObject || this.items[0] instanceof Common.StateObject2)) {
        var target = this.items.filter((obj,index)=>(this.$refs.listBox as Components.Grid).checked[index]);
        if (target.filter(obj=>obj.state != target[0].state).length > 0) hasDifferenceState = true;
      }
    }
    if (count == 0) {
      this.$api.modal.show('無効な操作', '削除する行を選択してください。', true, null);
    }else if (hasDifferenceState){
      this.$api.modal.show('無効な操作', '複数の伝票を処理する場合は、「状態」が同じものを選択してください。', true, null);
    } else if (hasStateObj) {

      //全て同じ状態の場合は、カスタムメッセージを表示する
      var target = this.items.filter((obj,index)=>(this.$refs.listBox as Components.Grid).checked[index]);

      //事前アクションの表示処理～複数処理に対応
      var sObj = target[0];
      var action = this.$api.perms.getDefaultAction(sObj.workflowCode, sObj.workflowId, sObj.workflowStateId, sObj.getTargetState(sObj.workflowStateId, Common.DefaultActionFlags.delete));    
      if (action){
        //デフォルトアクションボタンを表示する～複数の可能性もあるかも
        this.$api.modal.showDialog('先行アクション','削除を行う場合は事前に「' + action.actionName + '」を実施してください。',false, action.actionName,'キャンセル')
        .then(()=>{
          let p = Promise.resolve();       
          this.items.forEach((obj,index)=>{
            if((this.$refs.listBox as Components.Grid).checked[index]){
              //リストを更新する処理をプロミスに追加していく
              p = p.then(()=> this.$api.send(this.items[index],action.stateIdTo).then(updatedObj =>{
                // this.$set(this.items, index, updatedObj);
                this.onWorkflow(index,updatedObj); //ワークフロー更新用
              }));
            }
          });
          p.then(()=>this.$nextTick(()=>this.onDeleteExec(hasProvisioningData)));
        });
        return;
      }
      //事前アクションの表示処理～完了

      if(hasProvisioningData){
        //部門削除ダイアログを表示する
        this.deleteSampleMessage = target.filter(obj=>obj.state != target[0].state).length ==0 ? target[0].messageOnDelete: 'ワークフローが進行している行が含まれるため削除できません。' ;
        this.showDeleteSample = true;
        this.$api.issueGA4eventCommon({'event': 'dialog', 'message':this.deleteSampleMessage + '※サンプルデータの削除について<br>以下のリンクよりサンプル部門の伝票を全て削除することができます。その後、不要なマスタの削除を行ってください。'});
      } else {
        if (target.filter(obj=>obj.state != target[0].state).length ==0) this.$api.modal.show('無効な操作',target[0].messageOnDelete,true,null);
        else this.$api.modal.show('無効な操作', 'ワークフローが進行している行が含まれるため削除できません。', true, null);
      }      
    } else {

      var deleteHandler = this.deleteHandler;
      //標準機能
      if (deleteHandler == null) {
        deleteHandler = ()=>this.$api.modal.showDialog('確認メッセージ', count + '件のデータを本当に削除してよろしいですか?', false)
        .then(() => this.delete(this.selectedItems).catch(
          error => {
            if (error.message.indexOf('※サンプルデータの削除') > -1) {
              this.deleteSampleMessage = '使用されているため削除できませんでした。';
              this.showDeleteSample = true;
              this.$api.issueGA4eventCommon({'event': 'dialog', 'message':this.deleteSampleMessage + '※サンプルデータの削除について<br>以下のリンクよりサンプル部門の伝票を全て削除することができます。その後、不要なマスタの削除を行ってください。'});              
            }            
          }
        )); //更新処理エラーは握り潰してリスト更新を実行させる必要がある。
      }

      deleteHandler().then(()=>{
          this.onPageChange(this.params.currentPage);      
          this.$emit('updated');  
      });
    }
  }
  public async delete(targetList : any[]){
    for (const obj of targetList) {
      await this.$api.remove(obj);
    }
  }
  public async onExec(item: any) {
    if (this.isInsertMode) {
      return this.$api.add(item).then(obj => {this.onSubmit(obj);}); //onSubmitが非同期処理に変更されたため、onSubmitの完了を待たずに処理を戻す(編集画面を先にクローズさせるため)
    } else {
      return this.$api.update(item).then(obj =>{this.onSubmit(obj);}); //onSubmitが非同期処理に変更されたため、onSubmitの完了を待たずに処理を戻す(編集画面を先にクローズさせるため)
    }
  }

  public async onSubmit(obj: any) {
    // DBにコミットされたオブジェクトを受け取る
    // 新規・複製コミットの場合は、オブジェクトを末尾に追加して選択する。
    // 既存コミットの場合は、オブジェクトを入れ替えて再選択する。
    // コレクション変更扱いとなり高さが再計測される
    if (this.fullSizeEditor == false) {
      this.sideEditor.setState(Common.editorStates.Read);
    } else {
      //フルサイズエディタの表示
      this.editor.setState(Common.editorStates.Read);
    }

    this.isEditting = false;
    var insertMode = this.isInsertMode;

    if (this.isInsertMode) {
      this.isInsertMode = false;
      this.currentId = this.items.length; //末尾+1
      this.items.push(obj);//onItemsChangedが実行されるので先にcurrentIdを変更する
      (this.$refs.listBox as Components.Grid).resetChecked(); //onItemChanged側で追加を検知できないので手動呼出し
      // this.selectedId = this.items.length - 1;
      // this.$nextTick(() => this.listSelect(this.items.length - 1));
    } else {
      // 配列の更新に注意する
      this.$set(this.items, this.currentId, obj);
      this.$nextTick(() => this.listSelect(this.currentId));
    }
    this.$emit('updated');    

    //ダイアログ側での呼び出しに変更
    //新規追加時に後続処理がある場合、呼び出す。
    if (this.editFlag == editFlags.add && this.postAddHandler && insertMode) {
      // this.$api.modal.showDialog('確認メッセージ','伝票が新規保存されました。続けて明細の入力を行いますか？', false,'明細の入力','閉じる').then(()=>{
      //   this.$api.issueGA4event(this.$route.path,'明細の追加');
        this.selected = obj; //リスト更新前に後続処理の呼び出しが発生するため先にセット
        this.postAddHandler();
      // });
      return; //postAddHandlerがある場合は、事後アクションは実施しない。
    }

    //事後アクションの表示処理
    // if (obj instanceof Common.StateObject) {
    //   var action = this.$api.perms.getDefaultAction(obj.workflowCode, obj.workflowId, obj.workflowStateId, obj.getTargetState(obj.workflowStateId, insertMode ? Common.DefaultActionFlags.add : Common.DefaultActionFlags.update));    
    //   if (action){   
    //     //デフォルトアクションボタンを表示する～複数の可能性もあるかも
    //     return this.$api.modal.showDialog('後続アクション','このまま続けて「' + action.actionName + '」を実施しますか？',false, action.actionName,'キャンセル')
    //     .then(()=>this.$api.send(obj,action.stateIdTo)) //アクションの実施
    //     .then(updatedObj =>{
    //       // this.$set(this.items, this.currentId, updatedObj);
    //       this.onWorkflow(this.currentId, updatedObj);
    //     });//リストを更新して再度編集処理を実行する
    //   }
    // }    
  }

  public onClose() {
    //dialogModeでオーバーライドするためメソッドを変更
    if(this.dialogMode)this.dialogMode = false;
    this.onCancel();
  }
  public onCancel() {
    if (this.dialogMode && this.isInsertMode){
      this.dialogMode = false;
    }
    // キャンセルした場合は、元々選択されていたIdを再選択する。
    this.isInsertMode = false;

    // this.selected = this.items[this.selectedId];

    this.isEditting = false;
    // this.listSelect(this.currentId);
    this.$nextTick(() => this.listSelect(this.currentId));
  }

  public onWorkflow(index: number, obj: any) {
    var parent = this.$parent as any;
    //実装側のonWorkflowを呼び出す
    if (parent && parent.onWorkflow) parent.onWorkflow(index,obj);
  }
  //#endregion

  //#region お気に入り保存


  public isTenantFavorite: boolean = false;
  public favoriteEditorTitle: string = null;
  public onFavorite() {
    // this.favoriteName = '';
    if (this.isFavorite == false) {
      this.favorite = new Common.Favorite();
      this.favorite.name = '';
      this.favorite.viewName = this.title; //一覧名をセット
      this.favorite.path = this.$route.path;
      this.favorite.icon = this.icon;
      this.favorite.iconColor = this.color;
      this.favorite.owner = this.$api.auth.userId;
      this.favorite.shared = this.$api.auth.userId;
    }
    this.favoriteEditorTitle = this.isFavorite ? 'お気に入り更新' : 'お気に入り追加';
    this.isTenantFavorite = this.favorite.isTenant;
    this.favorite.json = JSON.stringify2(this.params);
    //ダイアログ表示
    this.showFavorite = true;
  }

  public addFavorite(event: any) {
    // if (this.favoriteName == '') {
    //   (this.$refs.favoriteName as any).validator.validate();
    //   event.cancel();
    //   return;
    // }

    const name = (this.$refs.favoriteName as any) as Components.IControl;
    // const owner = (this.$refs.favoriteOwner as any) as Components.IControl;
    // const shared = (this.$refs.favoriteShared as any) as Components.IControl;

    var validated1 = name.validator.validate();
    // var validated2 = owner.validator.validate();
    // var validated3 = shared.validator.validate();

    if (validated1 == false) {
      event.cancel();
      return;
    }

    //お気に入りの保存
    // const obj = new Common.Favorite();
    // obj.name = this.favoriteName;
    // obj.path = this.$route.path;
    // obj.icon = this.icon;
    // obj.iconColor = this.color;
    // obj.json = JSON.stringify2(this.params);

    if (this.isTenantFavorite) {
      this.favorite.owner = null; //所有者
      this.favorite.shared = null; //表示先=>テナント全体
    }
    //追加もしくは更新
    this.$api.update(this.favorite).then(res => {
      //サイドバーのリロード
      this.$root.$emit('sidebar');
    });
  }
  //#endregion

  public onCustomExport(exportQuery: Common.ExportQuery){
    exportQuery.loadQuery = this.params;
    this.$api.download(exportQuery);
  }
  public onCustomImport(importQuery: Common.ImportQuery){
    this.tempImportQuery = importQuery;
    this.tempImportQuery.userSheetName = importQuery.sheetName;
    this.showUpload = true;    
  }



  public onExport(layoutId:number, onlySelectedItems:boolean) {

    if (onlySelectedItems == false) {
      (this.exportQuery as Common.ExportQuery).loadQuery = this.params;
      (this.exportQuery as Common.ExportQuery).fileLayoutId = layoutId;
      (this.exportQuery as Common.ExportQuery).loadQuery.exportedItems = null;
      this.$api.download(this.exportQuery);
    } else {
      (this.exportQuery as Common.ExportQuery).fileLayoutId = layoutId;
      (this.exportQuery as Common.ExportQuery).loadQuery.exportedItems = this.selectedItems;
      this.$api.download(this.exportQuery).then(()=>{
        (this.exportQuery as Common.ExportQuery).loadQuery.exportedItems = null;    // export後にselectedItemsをリセット
      });
    }

    // if (this.selectedItems.length == 0) {
    //   this.$api.modal.showDialog('エクスポート','一覧全体をエクスポートします。よろしいですか？',false).then(()=>{
    //   (this.exportQuery as Common.ExportQuery).fileLayoutId = layoutId;
    //   (this.exportQuery as Common.ExportQuery).loadQuery.exportedItems = null;
    //   this.$api.download(this.exportQuery);
    //   });
    // } else {
    //   this.$api.modal.showDialog('エクスポート','チェックされた項目をエクスポートします。よろしいですか？',false).then(()=>{
    //   (this.exportQuery as Common.ExportQuery).fileLayoutId = layoutId;
    //   (this.exportQuery as Common.ExportQuery).loadQuery.exportedItems = this.selectedItems;
    //   this.$api.download(this.exportQuery);
    //   });
    // }
    // const query = new Common.ExportQuery(this.params);
    // (this.exportQuery as Common.ExportQuery).fileLayoutId = layoutId;
    // this.$api.download(this.exportQuery);
  }

  //カスタムインポートに対応
  tempImportQuery : Common.ImportQuery;
  public isBeforeUnPost:boolean = false;
  public isAfterPost:boolean = false;

  public onImport(layoutId:number) {
    this.uploadLayoutId = layoutId;
    this.tempImportQuery = this.importQuery as Common.ImportQuery;
    this.tempImportQuery.userSheetName = this.tempImportQuery.sheetName;
    //ファイル選択が必要    
    this.showUpload = true;
  }
  uploadLayoutId:number = null;
  public onImportExecute(event : any) {

    if ((this.$refs.sheetName as Components.TextBox).validator.validate() == false) {
      event.preventDefault();
      return;
    }

    const obj = (this.$refs.file as any).files as FileList;
    if (obj.length == 0) {
      this.$api.modal.showDialog('無効な操作','インポートファイルを選択してください',true).then(()=>this.showUpload = true);
      return;
    }
    
    (this.tempImportQuery as Common.ImportQuery).fileLayoutId = this.uploadLayoutId;
    (this.tempImportQuery as Common.ImportQuery).isBeforeUnPost = this.isBeforeUnPost;
    (this.tempImportQuery as Common.ImportQuery).isAfterPost = this.isAfterPost;
    this.$api.upload(this.tempImportQuery, obj).then(res =>{
      var links = [new Common.ModalLink(String.format('システムログ ID={0}',res),String.format('/operation/SystemLog?id={0}',res))];
      this.$api.modal.show('処理結果','インポート処理が開始されました。\r\nインポート結果は、通知のメール、または以下のリンクから確認できます。',true,null,links);      
    });
  }
  //#region リストボックスの制御

  public listSelect(index: number, focus: boolean = true) {
    if (this.$refs.listBox){
      if (focus && (this.isSideFilter == false || this.isEditting == false)) (this.$refs.listBox as Components.Grid).focus();
      if (this.items.length > index) {
        (this.$refs.listBox as Components.Grid).select(index);
      } else if (this.items.length > 0) {
        (this.$refs.listBox as Components.Grid).select(this.items.length - 1);
      } else {
        //一覧から選択できない場合はブランクにリセット
        this.selected = null;
      }
    } else if (this.dialogMode){
      //ダイアログモードでワークフローボタンを押した場合の挙動対応
      this.onSelected(index);
    }
  }

  /**
   * フォーカス行のINDEXを取得します。
   */
  public selectedId(): number {
    return (this.$refs.listBox as Components.Grid).selectedId;
  }
  /**
   * チェックボックスで選択された行(複数)を取得します。
   */
  public get selectedItems(): any[] {
    return (this.$refs.listBox as Components.Grid).selectedItems;
  }

  public onSelected(index: number) {
    // this.selectedId = index;
    this.selected = this.items[index];
    this.currentId = index;
    if(index > -1) this.$emit('selected', index,this.selected);
    //編集が完了した項目をpopupに設定する(ここで良いかどうか微妙)
    if(this.popup)this.popup.edittingItem = this.selected;
    
  }
  public onClicked(index: number){
    //spModeの場合、編集画面を表示する
    if (this.$api.spMode && this.$scopedSlots.sideEditor){
      this.setVisibleState('editor');
    }
  }
  //#endregion

  /**フィルタのフォーカス制御 */


  @Watch('isSideFilter')
  public onIsSideFilterChange() {
    //編集中はフォーカス制御をしない
    if (this.sideEditor && this.sideEditor.isEdit) return;

    if (this.isSideFilter) {
      // (this.$refs.sideFilterSplitter as Components.Splitter).reset(); //左右をリセットする
      this.$nextTick(() => {
        var focussableElements = 'select:not([disabled]), input[type=text]:not([disabled])';
        const target = this.$refs.search as HTMLElement;
        if (target){
          var focussable = target.querySelectorAll(focussableElements);
          if (focussable != null && focussable.length > 0) {
            const input = focussable[0] as HTMLElement;
            input.focus();
          }
        }
      });
    } else {
      (this.$refs.listBox as Components.Grid).focus();
    }
  }

  public campaigns: Common.Campaign[] = [];
  public showDialog:boolean = false;
  public campaignSrc: string = '';
  public campaignId:string = '';  
  public onFormClick(item:Common.Campaign){
    this.campaignId = item.id.toString();
    this.campaignSrc = 'https://forms.zohopublic.com/code-x/form/' + item.formGUID + '?userId=' + this.$api.auth.userId + '&userName=' + this.$api.auth.userName + '&campaignId=' + item.id + '&tenantId=' + this.$api.license.tenantId + '&tenantName=' + this.$api.license.tenantName + '&totalCount=' + item.totalCount + '&userCount=' + item.userCount;

    this.showDialog = true;
  }
  public onCampaignClose(){
    if (Common.Api.siteMode == Common.siteModes.tenant)
    {
      this.$api.loadCampaigns().then(res => 
      {
        this.campaigns = this.$api.campaigns.filter(obj =>obj.isCampaign==false);
      }
      );
    }

  }    
  public onFormSubmit(event:any){
    if (event.data == 'form_posted'){
      var webhook = new Common.Webhook();
      webhook.tenantid = this.$api.license.tenantId;
      webhook.userId = this.$api.auth.userId;
      webhook.userName = this.$api.auth.userName;
      webhook.campaignId= this.campaignId;
      this.$api.execute(webhook).then(res => this.onCampaignClose());
    } else if (event.data == 'form_closed'){
      this.showDialog = false;
    }
  }  
  @Watch('showDialog')
  public onFormClosed(){
    if (this.showDialog){
      //イベントリスナの挿入
      window.addEventListener('message',this.onFormSubmit);    
    } else {
      //イベントリスナの削除
      window.removeEventListener('message',this.onFormSubmit);    
    }
  }
  public conductTour(){

    // ***** 製品ツアーボタン押下確認 *****
    this.$api.issueGA4trackevent(this.$route.path,'【製品ツアー】ボタン押下');

    // (window as any).Appcues.show(this.tourId);
    (window as any).Intercom('startTour',this.tourId);    
  }

  public partialLoading = false;
  public onEndScrolled(){

    if(this.$api.spMode == false) return;

    if (this.items && this.items.length < this.totalRows && this.partialLoading == false)
    {
      this.partialLoading = true;
      var targetCount = (this.$refs.listBox as Components.Grid).defaultRowCount + 1;
      if (this.params.perPage != targetCount)
      {
        if (this.items.length < targetCount) {
          this.params.perPage = targetCount;
          this.params.currentPage = 1;
          this.$api.execute(this.params).then((data: Common.LoadResult) => {
                data.result.forEach(value => this.items.splice(this.items.length,this.items.length,value)); //入れ替える
                this.$nextTick(()=>this.partialLoading = false);         //listViewの@Watchを回避   
              });  
        }        
      }
      else
      {
        this.params.currentPage += 1;
        this.$api.execute(this.params).then((data: Common.LoadResult) => {
              data.result.forEach(value => this.items.splice(this.items.length,null,value));
              this.$nextTick(()=>this.partialLoading = false);         //listViewの@Watchを回避   
            });
      }

    }
  }
  public isMaster(): boolean {
    var path = this.$route.path;
    return this.$route.path.startsWith("/master/");
  }

  //部門削除ダイアログ
  public showDeleteSample: boolean = false;
  public deleteSampleMessage : string = '';
  public onDeleteSampleClick(){
    this.showDeleteSample = false;
    this.$api.modal.showDialog('確認メッセージ','サンプル部門の伝票を全て削除してよろしいですか？').then(()=>{
      var query = new Common.DummyQuery('DeleteSegmentQuery',null);
      return this.$api.execute(query).then(res =>{
        this.$api.modal.show('処理結果','削除処理を開始しました。\r\n結果はシステムログで確認できます。',true,null,[new Common.ModalLink('システムログに移動','/operation/SystemLog')]);
        return true;
      }).catch(()=>{return false;});;
    });
  }

  //ダイアログ最大化サポート
  public maximized : boolean = false;
  public onChangeDisplayMode(){
    this.maximized = !this.maximized;
  }
}
